import { Grid, Box, Row, Badge } from '@simplywallst/ui-core';

import { CompanyIcon } from '@/components/CompanyIcon';
import { CountryFlag } from '@/components/CountryFlag';

import type { ISO2 } from '@/constants/countries';

import {
  DetailsColumn,
  MiscColumn,
  NameContainer,
  SearchResultRow,
  Title,
  UniqueSymbol,
} from './styled';

export type Props = {
  type: 'primary';
  id: string;
  label: string;
  name: string;
  website: string | null;
  uniqueSymbol: string;
  tickerSymbol: string;
  exchangeCountryIso: ISO2 | null;
  tag: string | null;
};

export const PrimaryListing = ({
  label,
  exchangeCountryIso,
  tickerSymbol,
  uniqueSymbol,
  tag,
  website,
}: Props) => {
  return (
    <SearchResultRow data-cy-id={`primary-listing-${label}`}>
      <Box paddingLeft="x2">
        <CompanyIcon
          website={website}
          tickerSymbol={tickerSymbol ?? uniqueSymbol?.split?.(':')?.[1]}
          size={40}
        />
      </Box>
      <NameContainer>
        <DetailsColumn>
          <Row>
            <Title>{label}</Title>
          </Row>
          <Grid templateColumns="24px auto" alignItems="center">
            <CountryFlag countryISO={exchangeCountryIso} />
            <UniqueSymbol>{uniqueSymbol}</UniqueSymbol>
          </Grid>
        </DetailsColumn>
        <MiscColumn>{tag && <Badge>{tag}</Badge>}</MiscColumn>
      </NameContainer>
    </SearchResultRow>
  );
};
